function openTabFeed(e, t, a) {
  var l = document.getElementsByClassName("products-feed__tabcontent--" + t);
  for (let e = 0; e < l.length; e++) l[e].style.display = "none";
  var c = document.getElementsByClassName("products-feed__tablinks--" + t);
  for (let e = 0; e < c.length; e++) c[e].className = c[e].className.replace(" active", "");
  document.getElementById(a).style.display = "block", e.currentTarget.className += " active"
}
document.querySelectorAll("[data-default-open]").forEach(e => {
  e.click()
}), window.addEventListener("shopify:section:load", () => {
  document.querySelectorAll("[data-default-open]").forEach(e => {
    e.click()
  })
});